import Keycloak, { type KeycloakConfig } from 'keycloak-js';

const loadExternalScript = (url: string): Promise<string> =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.setAttribute('src', url);
    script.onload = () => {
      resolve(`${url} récupéré avec succès.`);
    };
    script.onerror = () => {
      reject(new Error(`Problème lors de la récupération de ${url}.`));
    };

    document.head.appendChild(script);
  });

export async function createKeycloak({ url, realm, clientId }: KeycloakConfig): Promise<Keycloak> {
  if (!url) {
    throw new Error(`Le paramètre de configuration "url" est obligatoire.`);
  }
  if (!realm) {
    throw new Error(`Le paramètre de configuration "realm" est obligatoire.`);
  }
  if (!clientId) {
    throw new Error(`Le paramètre de configuration "clientId" est obligatoire.`);
  }

  await loadExternalScript(`${url}/js/keycloak.js`);

  return new Keycloak({ url, realm, clientId });
}
